import React from 'react';
import AppraisalSamplingDetails from './AppraisalSamplingDetails';
import { useCheckPointFile } from '@shared/hooks/useCheckPointFile';

/**
 * @typedef {object} UnitDetailsBoxProps
 * @property {Object} [data]
 * @property {Object} [rationaleDocument]
 * @property {boolean} [showAppraisalDetails]
 * @property {boolean} [showUnitDetails]
 * @property {(MddapOrgUnitId: number) => void} [handleSelectUnit]
 */

/**
 * @param {UnitDetailsBoxProps} props
 */
const UnitDetailsBox = props => {
  const {
    rationaleDocument,
    handleSelectUnit,
    data: {
      sponsorName = '',
      location = '',
      FEI = '',
      enrollmentDate = '',
      OHTs = '',
      appraisalUnits = [],
      appraisalDate = '',
      appraisalID = 0,
      teamLeadName = ''
    } = {},
    showUnitDetails = true,
    showAppraisalDetails = true
  } = props;

  const { downloadFile } = useCheckPointFile();

  const handleFileDownload = async event => {
    event.preventDefault();

    await downloadFile(rationaleDocument.CheckpointId, rationaleDocument.FileName);
  };

  const getAppraisalUnits = () => {
    if (!appraisalUnits || appraisalUnits.length <= 1) {
      return 'N/A';
    }

    return (
      <ul className='no-margin'>
        {appraisalUnits.map(orgUnit => (
          <li key={orgUnit.Id}>
            {orgUnit.IsUserHasAccessOrgUnit ? (
              <a onClick={() => handleSelectUnit(orgUnit.MddapOrgUnitId)}>{orgUnit.Name}</a>
            ) : (
              orgUnit.Name
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className='unit-details-box'>
      {showUnitDetails && (
        <span className='unit-details'>
          <h4>Unit Details</h4>
          <p>
            <strong>Sponsor: </strong>
            {sponsorName}
          </p>
          <p>
            <strong>Location: </strong>
            {location}
          </p>
          <p>
            <strong>FEI #: </strong>
            {FEI}
          </p>
          <p>
            <strong>Enrollment Date: </strong>
            {enrollmentDate}
          </p>
          <p>
            <strong>OHTs: </strong>
            {!OHTs.length ? 'N/A' : OHTs}
          </p>
        </span>
      )}
      {showAppraisalDetails && (
        <>
          <span className='appraisal-details'>
            {showUnitDetails && <br />}
            <h4>Appraisal Details</h4>
            <p>
              <strong>Appraisal Date: </strong>
              {appraisalDate}
            </p>
            <p>
              <strong>Appraisal ID: </strong>
              {appraisalID}
            </p>
            <p>
              <strong>Lead Appraiser: </strong>
              {teamLeadName}
            </p>
            {rationaleDocument && (
              <p>
                <a onClick={handleFileDownload}>Reappraisal Rationale</a>
              </p>
            )}
            <div data-testid='multi-site-units-section'>
              <strong>Multi-Site: </strong>
              {getAppraisalUnits()}{' '}
            </div>
          </span>
          <span data-testid='sampling-header'>
            <br />
            <h4>Sampling Details</h4>
            <AppraisalSamplingDetails appraisalUnits={appraisalUnits} />
          </span>
        </>
      )}
    </div>
  );
};

export default UnitDetailsBox;
